var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.267 162.421C429.05 78.31 349.492 17.539 256 17.539S82.95 78.31 54.733 162.421H0v134.68h54.733c15.572 46.421 46.78 85.729 87.341 111.639H79.329v85.72h353.342v-85.72h-62.746c40.562-25.911 71.769-65.22 87.342-111.639H512v-134.68h-54.733zM46.504 263.711H33.391v-67.898h13.113a212.886 212.886 0 00-2.728 33.949c0 11.554.942 22.891 2.728 33.949zm352.776 178.42v18.937H112.72v-18.937h286.56zM256 408.594c-98.608 0-178.832-80.224-178.832-178.833C77.168 131.154 157.392 50.93 256 50.93s178.832 80.224 178.832 178.832c0 98.609-80.224 178.832-178.832 178.832zm222.609-144.883h-13.113c1.785-11.058 2.728-22.394 2.728-33.949s-.942-22.891-2.728-33.949h13.113v67.898z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 93.665c-85.966 0-155.904 61.053-155.904 136.095S170.034 365.858 256 365.858s155.904-61.054 155.904-136.096S341.966 93.665 256 93.665zm0 238.802c-67.554 0-122.513-46.074-122.513-102.705S188.446 127.058 256 127.058s122.513 46.073 122.513 102.704S323.554 332.467 256 332.467z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/Astronaut.5a37b3da.svg";
export { ForwardRef as ReactComponent };